exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: #03050c;\n}\r\n", ""]);

// exports
